<template>
  <header>
    <button v-if="hasBack" class="back d4-left" @click="$router.go(-1)"></button>
    <button v-else-if="isAdmin" class="d4-admin" @click="$router.push({name: 'admin'})" title="Åpen admin"></button>
    <div v-else-if="$store.state.user.isLoggedIn" class="spacer"></div>
    <span style="text-align: center">
      <h2>{{routeTitle || $store.state.route.name}}</h2>
      <a style="font-size: 13px; opacity: .72" href="https://medlem.thaugland.no">medlem.thaugland.no</a>
    </span>
    <button class="logout d4-logout" v-if="$store.state.user.isLoggedIn" @click="logout" title="Logg ut"></button>
    <transition name="fade">
      <div v-if="aMessage" id="message" @click="$store.commit('user/message', null)">
        <h4>{{aMessage.title}}<i class="d4-close"></i></h4>
        <p>{{aMessage.body}}</p>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'Header',
  computed: {
    routeMeta () {
      return this.$store.state.route.meta || {}
    },
    routeTitle () {
      return this.routeMeta.title || ''
    },
    hasBack () {
      return this.routeMeta.back
    },
    isAdmin () {
      return this.$store.state.user.roles && this.$store.state.user.roles.admin
    },
    aMessage () {
      return this.$store.state.user.message
    },
  },
  methods: {
    logout () {
      const { confirm } = window
      if (!confirm || confirm('Er du sikker på at du vil logge ut?')) this.$store.dispatch('user/logout')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 12vh;
  max-height: 88px;
  --topLightColor: #ebc57d;
  --bottomLightColor: #e8b657;
  background: var(--topLightColor);
  background: linear-gradient(to bottom, var(--topLightColor) 0%,var(--bottomLightColor) 100%);

  h2 {
    color: var(--primary);
    font-family: var(--altFont);
    margin: 0 16px;
    text-transform: uppercase;
    font-size: 22rem;
    line-height: 1;
    flex: 1;
    text-align: center;
  }

  button {
    width: 60px;
    height: 100%;
    color: var(--primary);
    font-size: 24rem;
  }

  .spacer {
    width: 60px;
  }
}

#message {
  position: fixed;
  z-index: 9;
  top: 30%;
  left: 50%;
  margin-left: -150px;
  width: 300px;
  padding: 16px;
  background: var(--yellow);
  border-radius: 8px;
  box-shadow: 0 2px 8px var(--dark-faded);

  h4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
